import React from 'react';
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ children, allowedRoles }) => {
  const token = localStorage.getItem('token');
  const role = parseInt(localStorage.getItem('role'));

  if (!token) return <Navigate to="/" replace />; // not loged in 

  if (allowedRoles && !allowedRoles.includes(role)) {
    return <Navigate to="/unauthorized" replace />; //role not allowed
  }

  return children;
};

export default PrivateRoute;
